import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgClass } from '@angular/common';
import { ResponsiveComponent } from '@nx-superprep/shared'

import { SearchbarComponent, SearchState } from '@nx-superprep/shared'
import { NavigationBarComponent, NavigationBarState } from '../../navigationbar/navigationbar.component'
import { BsModalService } from 'ngx-bootstrap/modal'

export interface UserState { name: string, greeting: string, avatar: {src: string, alt:string} }
@Component({
  selector: 'pop-ui-dashboard-content-header',
  standalone: true,
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss'],
  imports: [
    NgClass,
    SearchbarComponent,
    NavigationBarComponent,
  ],
  providers: [BsModalService]
})
export class HeaderComponent extends ResponsiveComponent {
  isMenuCollapsed = true

  override get rootClassName() { return `${super.rootClassName}${this.collapsed ? ' collapsed' : ''}` }

  private _navigation!: NavigationBarState
  @Input()
  get navigation() {
    return this._navigation
  }
  set navigation(value) {
    if (value.action === 'back') {
      this.navigationChange.emit(value)
    } else {
      this._navigation = value
    }
  }
  @Output() navigationChange = new EventEmitter<NavigationBarState>()

  override handleSearchChange(value: SearchState): void {
    this.searchChange.emit(value)
  }

  private _template = 'home'
  @Input()
  get template() { return this._template }
  set template(value) {
    if (this._template !== value) {
      switch (value) {
        case 'home': {
          this.search.selected = undefined; this.search.visible = true
          this._navigation = { title: `Home`, current: { route: value, type: 'root' }}
        } break
        case 'library': {
          this.search.selected = undefined; this.search.visible = true
          this._navigation = { title: 'Explore', current: { route: value, type: 'root' }}
        } break
        case 'performance': {
          this.search.selected = undefined; this.search.visible = true
          this._navigation = { title: 'Performance', current: { route: value, type: 'root' }}
        } break
        case 'brushup': {
          this.search.selected = undefined; this.search.visible = false
          this._navigation = { title: 'Brushup', current: { route: value, type: 'root' }}
        } break
      }
    }
    this._template = value
  }

  get isHome() { return this.template === 'home' }

  get isNavigationVisible() { return true }
  get isSearchVisible() { return false /* this.search.visible */ }
  override get isDark() { return !this.isWeb && (this.isHome || (this.navigation.segments??[]).length === 0) }

  activeDate: Date = new Date()

  constructor() {
    super()
    super.rootClassName = 'content-header-root-class-name';
  }
}
